export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  credentials: (state) => state.credentials,
  invitation: (state) => state.invitation,
  modal: (state) => state.modal,
};
